export const COOKIES_TERMS_QUERY_KEY = 'cookies-terms-query-key';
